import type { ServerResponseV1 } from "@/http"
import type { ISlideshowVideoJobResponse } from "@/types"
import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"
import { SlideshowVideoJob } from "@/models"

export interface IGenerateSlideshowVideoParams {
  id: string
  eventVaultId: number
  musicAssetId?: number
  skipBackgroundMusic?: boolean
}

export async function generateSlideshowVideo({ id, eventVaultId, musicAssetId, skipBackgroundMusic }: IGenerateSlideshowVideoParams) {
  const endpoint = `/${eventVaultId}/slideshow/${id}/video`

  const payload = {
    musicAssetId: musicAssetId ?? null,
    skipBackgroundMusic: skipBackgroundMusic ?? false,
  }

  const response = await v1.post<ServerResponseV1<ISlideshowVideoJobResponse>>(endpoint, payload)

  return SlideshowVideoJob.fromResponse(response.data.data)
}

export function useGenerateSlideshowVideo() {
  return useMutation({
    mutationFn: (params: IGenerateSlideshowVideoParams) => generateSlideshowVideo(params),
  })
}
